import TextLink from './TextLink.vue'

export default TextLink
